(function () {
  var instances = [];

  function normalizeTags(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // A card counts as live unless the schedule marked it (or its whole block) as not live.
  // The theme editor shows everything, so scheduling never hides cards there.
  function isLive(card) {
    if (window.Shopify && window.Shopify.designMode) return true;
    if (card.hasAttribute('data-td-editor')) return true;
    if (card.getAttribute('data-td-live') === 'false') return false;
    var grid = card.closest('[data-td-promo-grid]');
    return !(grid && grid.getAttribute('data-td-live') === 'false');
  }

  function setActive(pill, active) {
    pill.classList.toggle('is-active', active);
    pill.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function init(root) {
    if (root.dataset.tdFilterInit) return;
    root.dataset.tdFilterInit = 'true';

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-td-pill], [data-td-pill-all]'));
    var clearBtn = root.querySelector('[data-td-clear]');
    var multi = root.getAttribute('data-multi-select') === 'true';

    function activeTags() {
      var out = [];
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all') || p.hidden) return;
        if (p.classList.contains('is-active')) {
          out.push(p.getAttribute('data-td-pill'));
        }
      });
      return out;
    }

    function setAllActive(allActive) {
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all')) {
          setActive(p, allActive);
        } else if (allActive) {
          setActive(p, false);
        }
      });
    }

    // Hide pills that match no promo card on the page; deactivate any that
    // became dead (e.g. its cards were removed in the theme editor).
    function prunePills() {
      var available = {};
      document.querySelectorAll('.td-promo-card[data-tags]').forEach(function (card) {
        if (!isLive(card)) return;
        normalizeTags(card.getAttribute('data-tags')).forEach(function (t) { available[t] = true; });
      });
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all')) return;
        var dead = !available[p.getAttribute('data-td-pill')];
        p.hidden = dead;
        if (dead) setActive(p, false);
      });
    }

    function applyFilter(updateUrl) {
      prunePills();

      var tags = activeTags();
      var hasActive = tags.length > 0;

      if (!hasActive) setAllActive(true);

      // Find every promo card on the page (across multiple grids if present)
      var cards = document.querySelectorAll('.td-promo-card[data-tags]');
      cards.forEach(function (card) {
        var cardTags = normalizeTags(card.getAttribute('data-tags'));
        var visible = isLive(card) && (!hasActive || tags.every(function (t) { return cardTags.indexOf(t) !== -1; }));
        card.style.display = visible ? '' : 'none';
      });

      // Each deal block either hides itself when every card in it is filtered
      // out (data-td-empty-mode="hide") or keeps showing with its message.
      // When every block on the page is empty, the first one stays visible so
      // its "no deals match" message has somewhere to appear.
      var grids = document.querySelectorAll('[data-td-promo-grid]');
      var visibleGrids = 0;
      grids.forEach(function (grid) {
        var anyInGrid = false;
        grid.querySelectorAll('.td-promo-card[data-tags]').forEach(function (c) {
          if (c.style.display !== 'none') anyInGrid = true;
        });
        grid.classList.toggle('is-empty', !anyInGrid);
        grid.classList.remove('is-empty--only');
        var empty = grid.querySelector('[data-td-empty]');
        if (empty) empty.hidden = anyInGrid;
        if (anyInGrid) visibleGrids++;
      });
      // Only a filter can produce the "no deals match" message; when every card is simply
      // off-schedule the blocks stay hidden.
      if (hasActive && visibleGrids === 0 && grids.length) grids[0].classList.add('is-empty--only');

      if (clearBtn) clearBtn.hidden = !hasActive;

      // Oct 19 promos (fix round 1): a wide card left alone in its row takes the whole row (deals-schedule.js).
      if (window.tdFillRows) window.tdFillRows();

      // Keep the filter state in the URL so it survives reload/back and can
      // be shared. Uses replaceState, so no history entries pile up.
      if (updateUrl !== false && window.history && history.replaceState) {
        var url = hasActive
          ? '#deals=' + tags.map(encodeURIComponent).join(',')
          : window.location.pathname + window.location.search;
        history.replaceState(null, '', url);
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('data-td-pill-all')) {
          setAllActive(true);
        } else {
          if (multi) {
            setActive(pill, !pill.classList.contains('is-active'));
          } else {
            var wasActive = pill.classList.contains('is-active');
            pills.forEach(function (p) {
              if (!p.hasAttribute('data-td-pill-all')) setActive(p, false);
            });
            setActive(pill, !wasActive);
          }
          setAllActive(activeTags().length === 0);
        }
        applyFilter();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        setAllActive(true);
        applyFilter();
      });
    }

    // Restore filter state from the URL (#deals=dog,dry%20food)
    var match = window.location.hash.match(/^#deals=(.+)$/);
    if (match) {
      var restore = match[1].split(',').map(function (s) {
        try { return decodeURIComponent(s); } catch (e) { return s; }
      });
      prunePills();
      var restored = 0;
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all') || p.hidden) return;
        if (restore.indexOf(p.getAttribute('data-td-pill')) !== -1 && (multi || restored === 0)) {
          setActive(p, true);
          restored++;
        }
      });
      setAllActive(activeTags().length === 0);
    }

    applyFilter(false);

    instances.push({ root: root, apply: applyFilter });
  }

  function bootstrap() {
    document.querySelectorAll('[data-td-filter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Theme editor: sections re-render with fresh DOM. Re-init any new filter
  // sections and re-apply active filters to re-rendered promo grids.
  // (This event only fires inside the editor.)
  // The schedule script flips cards on and off as their dates arrive; re-run the filter so
  // block visibility and the pills follow.
  document.addEventListener('td:schedule', function () {
    instances.forEach(function (i) { i.apply(false); });
  });

  document.addEventListener('shopify:section:load', function () {
    instances = instances.filter(function (i) { return document.contains(i.root); });
    bootstrap();
    instances.forEach(function (i) { i.apply(false); });
  });
})();
